import { useState } from 'react'
import { Grid, Typography } from '@mui/material'
import InCardStack, { ColStack } from 'components/atoms/container/InCardStack'
import { useNavigate } from 'react-router-dom'
import { ADD_ASSESSMENT_RATERS, MY_JOURNEY } from 'routes/constants'
import { useTranslation } from 'react-i18next'
import RowStack from 'components/atoms/container/RowStack'
import RadarGraphNew from './pathAssessment/RadarGraphNew'
import OverallScoreBox from 'components/molecules/assessments/OverallScoreBox'
import NavigateButtons from 'components/molecules/onboarding/NavigateButtons'
import CommonDialog from '../notificationOverlay/CommonDialog'
import AddRaterPageCard from 'components/organisms/assessments/AddRaterPageCard'

const SelfAssessmentReport = ({
  resultData,
  nextStepCallback,
  disableBehaviorClick,
  fromOnboarding = false,
  fromSelfAssessment = false
}) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [skipDialogOpen, setSkipDialogOpen] = useState(false)
  const [showAddRaters, setShowAddRaters] = useState(false)
  const enableOthersAssessment = resultData.goalData?.enableOthersAssessment

  const handleNextStep = () => {
    if (fromOnboarding || fromSelfAssessment) {
      if (enableOthersAssessment && !showAddRaters) {
        setShowAddRaters(true)
      } else if (nextStepCallback) {
        nextStepCallback(false)
      }
    } else if (enableOthersAssessment) {
      navigate(`${ADD_ASSESSMENT_RATERS}/${resultData.goalData.id}`, {
        state: { fromSelfAssessment: true, assessmentData: resultData }
      })
    } else {
      navigate(MY_JOURNEY)
    }
  }

  const handleSkipDialogClose = async askFeedback => {
    if (askFeedback === null) return
    setSkipDialogOpen(false)
    if (askFeedback) {
      if (!showAddRaters) handleNextStep()
    } else {
      if (nextStepCallback) {
        nextStepCallback(true)
      } else {
        navigate(MY_JOURNEY)
      }
    }
  }

  return (
    <>
      {!showAddRaters ? (
        <ColStack data-testid='self-assessment-report' spacing={16}>
          <RowStack justifyContent='space-between'>
            <ColStack spacing={4} flex={1}>
              <Typography variant='h3'>{resultData?.goalData?.name}</Typography>
              <Typography variant='body1Small'>
                {t('assessmentTimeline.compareYourScores')}
              </Typography>
            </ColStack>

            <OverallScoreBox
              selfScore={resultData.selfAllBehaviourAvg}
              otherScore={resultData.otherAllBehaviourAvg}
            />
          </RowStack>

          <InCardStack width='100%'>
            <RadarGraphNew
              assessmentData={resultData}
              showScoreLabel={true}
              disableBehaviorClick={disableBehaviorClick}
            />

            {disableBehaviorClick ? null : (
              <Typography color='primary' fontStyle='italic'>
                {t('goalsArea.clickBehaviours')}
              </Typography>
            )}
          </InCardStack>

          <Grid position='sticky'>
            <NavigateButtons
              backLabel={t('assessmentTimeline.skipFeedback')}
              backProps={{
                startIcon: undefined
              }}
              onBack={() => setSkipDialogOpen(true)}
              nextLabel={
                enableOthersAssessment
                  ? t('assessmentTimeline.askFeedback')
                  : t('common.done')
              }
              nextProps={{
                ...(!enableOthersAssessment ? { endIcon: undefined } : {})
              }}
              onNext={handleNextStep}
            />
          </Grid>
        </ColStack>
      ) : (
        <AddRaterPageCard
          goalId={resultData.goalData?.id}
          assessmentData={resultData}
          containerProps={{
            paddingTop: 0
          }}
          addRatersProps={{
            fromOnboarding: fromOnboarding,
            completeCallback: completed => {
              if (completed) {
                handleNextStep()
              } else {
                setSkipDialogOpen(true)
              }
            }
          }}
        />
      )}
      {skipDialogOpen && (
        <CommonDialog
          open={skipDialogOpen}
          onClose={handleSkipDialogClose}
          titleText={t('assessmentTimeline.sureWantToSkip')}
          notificationText={t('assessmentTimeline.powerfulWayToBuild')}
          confirmText={t('assessmentTimeline.askFeedback')}
          cancelText={t('common.continue')}
          onCloseValue={null}
        />
      )}
    </>
  )
}

export default SelfAssessmentReport
